import { Translation } from "@shared/types/translation";
import { useLocale } from "@translations/locale-context";
import Image from "next/legacy/image";
import React from "react";

const WORKSHOP: {
    srcDesktop: Translation;
    srcMobile: Translation;
}[] = [
    {
        srcDesktop: {
            cs: "/static/landing-pages/workshop-desktop-cz.png",
            en: "/static/landing-pages/workshop-desktop-en.png",
        },
        srcMobile: {
            cs: "/static/landing-pages/workshop-mobile-cz.png",
            en: "/static/landing-pages/workshop-mobile-en.png",
        },
    },
];

const ContentCs = () => (
    <>
        <h2 className="pb-4 text-h2Mobile font-bold text-uxfViolet sm:text-medium xl:text-h5">
            Každý náš audit začíná <span className="text-uxfOrange">společným workshopem</span>
        </h2>
        <p className="text-small1 text-uxfMuted75 sm:text-body">Pomůže oběma stranám správně pochopit vaše potřeby.</p>
    </>
);

const ContentEn = () => (
    <>
        <h2 className="pb-4 text-h2Mobile font-bold text-uxfViolet sm:text-medium xl:text-h5">
            Every audit begins with a&nbsp;<span className="text-uxfOrange">joint workshop</span>
        </h2>
        <p className="text-small1 text-uxfMuted75 sm:text-body">
            It will help both parties to understand your needs correctly.
        </p>
    </>
);

export const WorkshopSection = () => {
    const locale: "cs" | "en" = useLocale();
    return (
        <div className="container px-5 py-10 md:px-0">
            <div className="sm:pb-12">{locale === "en" ? <ContentEn /> : <ContentCs />}</div>
            {WORKSHOP.map(({ srcDesktop, srcMobile }, index) => (
                <div key={index}>
                    <div className="max-md:hidden">
                        <Image
                            src={srcDesktop[locale]}
                            alt={locale === "en" ? "Joint workshop steps" : "Kroky společného workshopu"}
                            width={1208}
                            height={272}
                        />
                    </div>
                    <div className="mx-5 py-7 text-center md:hidden">
                        <Image
                            src={srcMobile[locale]}
                            alt={locale === "en" ? "Joint workshop steps" : "Kroky společného workshopu"}
                            width={317}
                            height={529}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};
